import type { SvgIconProps } from 'types/icon';
import Error from '@mui/icons-material/Error';
import ErrorOutline from '@mui/icons-material/ErrorOutline';

export const ErrorIcon = ({ color = 'error', ...props }: SvgIconProps) => (
  <Error color={color} {...props} />
);

export const ErrorOutlineIcon = ({
  color = 'error',
  ...props
}: SvgIconProps) => <ErrorOutline color={color} {...props} />;
